import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const CircleOutlineIcon = (t0)=>{
    const $ = c(7);
    const { width, height, color } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("rect", {
            x: "1",
            y: "1",
            width: "14",
            height: "14",
            rx: "7",
            fill: "white"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== color) {
        t2 = /*#__PURE__*/ jsx("rect", {
            x: "1",
            y: "1",
            width: "14",
            height: "14",
            rx: "7",
            stroke: color,
            strokeWidth: "2"
        });
        $[1] = color;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== height || $[4] !== t2 || $[5] !== width) {
        t3 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2
            ]
        });
        $[3] = height;
        $[4] = t2;
        $[5] = width;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
export { CircleOutlineIcon };
